import React from 'react'
import PropTypes from 'prop-types'

import FacebookAdPreviewContainer from '../reusablePreviewComponents/FacebookAdPreviewContainer'
import FacebookAdPreviewHeader from '../reusablePreviewComponents/FacebookAdPreviewHeader'
import FacebookSingleMediaAdThumbnail from './FacebookSingleMediaAdThumbnail'
import FacebookSingleMediaAdFooter from './FacebookSingleMediaAdFooter'

import {
  FILE_ID,
  FILE_NAME,
  FILE_URL,
  IMAGE_HASH,
  MEDIA_TYPE,
  SINGLE_MEDIA_ITEM,
  VIDEO_PICTURE
} from '../../../../forms/ReusableFormFields/AdFileUpload/fields'

const FacebookSingleMediaAdPreview = ({
  elementInProgress,
  viewAdOnFacebook,
  formikValues,
  isInProgress,
  isSoundMuted,
  mediaThumbnailImageRatio
}) => {
  // todo refactor to use only formikValues[SINGLE_MEDIA_ITEM]
  const mediaFile = {
    [MEDIA_TYPE]: formikValues[SINGLE_MEDIA_ITEM]
      ? formikValues[SINGLE_MEDIA_ITEM][MEDIA_TYPE]
      : formikValues[MEDIA_TYPE],
    [FILE_NAME]: formikValues[SINGLE_MEDIA_ITEM] ? formikValues[SINGLE_MEDIA_ITEM][FILE_NAME] : formikValues[FILE_NAME],
    [FILE_URL]: formikValues[SINGLE_MEDIA_ITEM] ? formikValues[SINGLE_MEDIA_ITEM][FILE_URL] : formikValues[FILE_URL],
    [IMAGE_HASH]: formikValues[SINGLE_MEDIA_ITEM]
      ? formikValues[SINGLE_MEDIA_ITEM][IMAGE_HASH]
      : formikValues[IMAGE_HASH],
    [VIDEO_PICTURE]: formikValues[SINGLE_MEDIA_ITEM]
      ? formikValues[SINGLE_MEDIA_ITEM][VIDEO_PICTURE]
      : formikValues[VIDEO_PICTURE],
    [FILE_ID]: formikValues[SINGLE_MEDIA_ITEM] ? formikValues[SINGLE_MEDIA_ITEM][FILE_ID] : formikValues[FILE_ID]
  }

  return (
    <FacebookAdPreviewContainer>
      <FacebookAdPreviewHeader elementInProgress={elementInProgress} formikValues={formikValues} />
      <FacebookSingleMediaAdThumbnail
        viewAdOnFacebook={viewAdOnFacebook}
        mediaFile={mediaFile}
        isInProgress={isInProgress}
        isSoundMuted={isSoundMuted}
        mediaThumbnailImageRatio={mediaThumbnailImageRatio}
      />
      <FacebookSingleMediaAdFooter elementInProgress={elementInProgress} formikValues={formikValues} />
    </FacebookAdPreviewContainer>
  )
}

FacebookSingleMediaAdPreview.propTypes = {
  elementInProgress: PropTypes.string,
  viewAdOnFacebook: PropTypes.string,
  formikValues: PropTypes.object,
  isInProgress: PropTypes.bool,
  isSoundMuted: PropTypes.bool,
  mediaThumbnailImageRatio: PropTypes.number
}

export default FacebookSingleMediaAdPreview
